import styled from 'styled-components';

const Discount = styled.div`
display: inline-block;
height: 32px;
font-size: 25px;
text-align: center;
padding: 0 6px;
background-color: #4c6b22;
color: #a4d007;
`;

export default Discount;

